<label mat-dialog-title class="uk-text-title">{{ list.title }}</label>
<mat-dialog-content>
  <mat-nav-list>
    <mat-divider></mat-divider>
    <ng-container  *ngFor="let item of list.data; let i = index">
      <a mat-list-item>
        <b class="me-3">{{ i + 1 }}</b>
        {{
          item.hierarchyBreadcrumb
            ? item.hierarchyBreadcrumb.slice(
              0,
              item.hierarchyBreadcrumb.indexOf(item.hierarchyDescription)
            )
            : ""
        }}
        {{ item.hierarchyDescription }}
      </a>
      <mat-divider></mat-divider>
    </ng-container>

    <ng-container *ngFor="let item of list.data2; let x = index">
      <a mat-list-item>
        <b class="me-3">{{ list.data.length + x + 1 }}</b>
        {{
          item.attributeBreadcrumb
            ? item.attributeBreadcrumb.slice(
              0,
              item.attributeBreadcrumb.indexOf(
                item.attributeDescription
              )
            )
            : ''
        }}
        {{ item.attributeDescription }}
      </a>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-nav-list>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button
    mat-flat-button
    id="cancel"
    class="border-box m-4"
    (click)="onNoClick()"
    type="button"
  >
    Salir
  </button>
</mat-dialog-actions>
<button id="closeAddAddress" mat-button mat-dialog-close class="dialog-close">
  <mat-icon>close</mat-icon>
</button>


